import { Box, Button } from '@mui/material'
import { styled } from '@mui/system'
import { AddIcon, MinusIcon } from '../../icons'

// TODO Change to use IconButton3 with xxSmall size
const SmallIconButtons = styled(Button)({
  width: 16,
  height: 16,
  minWidth: 16,
  padding: 2,
  gap: 4,
  svg: {
    height: 12,
    width: 12,
  },
})

const SliderPlusMinus = ({
  value,
  disabled,
  onButtonClick,
}: {
  value: number
  disabled: boolean
  onButtonClick: (newValue: number) => void
}) => {
  return (
    <Box display="flex" flexDirection="row" gap="6px" marginTop="4px">
      <SmallIconButtons variant="outlined" disabled={disabled} onClick={() => onButtonClick(value - 1)}>
        <MinusIcon />
      </SmallIconButtons>
      <SmallIconButtons variant="outlined" disabled={disabled} onClick={() => onButtonClick(value + 1)}>
        <AddIcon />
      </SmallIconButtons>
    </Box>
  )
}

export default SliderPlusMinus
